import { create } from 'zustand';
import { getActions } from './actions.js';
export const DEFAULT_USER_INFO_STATE = {
    identifier: '',
    identifierType: undefined,
    countryCode: '+1',
    recoveryShare: null,
};
export const useUserInfoStore = create((set, get) => (Object.assign(Object.assign({}, DEFAULT_USER_INFO_STATE), getActions(set, get))));
